module.exports = __webpack_public_path__ + "static/media/restaurant-6.07bab676.jpg";